import FormModals from "./FormModals.vue";

export { FormModals };
